import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CardSetTransformationService, CoreService, DataService, DialogService, SaveDataRequest, SaveFormEvent, SpinnerService, VerticalNavigationSettings } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from 'src/app/constants/api-endpoints.constants';
import { APP_DATA_KEYS, POP_UP_CODES, SAVE_RESULT_STATUS, SERVER_ERROR_POP_UP_CODES } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';

@Component({
  selector: 'app-payment-rule',
  templateUrl: './payment-rule.component.html',
  styleUrls: ['./payment-rule.component.scss']
})
export class PaymentRuleComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy {

  fieldTypeReplacements =
    CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  verticalNavigationSettings: VerticalNavigationSettings = { enabled: true, sticky: true, pageLevel: true };
  //formNavSubscription: Subscription;

  templateId: number = TEMPLATES.concessionsRebateCalculationRule;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  editing: boolean = false;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {

    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const id = paramMap.get('id');
        if (id) {
          this.id = id;
          this.formServiceEndpoint = API_ENDPOINT_KEYS.getRuleConfigAndResponse;
          this.editing = true;
        }
        else {
          this.resetDirtyFlagAfterLoading();
        }
      })
    );

    this.coreService.conditionFunctions['isEditing'] = () => this.editing;
    this.coreService.applicationFunctions['exit'] = () => this.exit;
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }
  formLoaded($event) {
    if (this.baseForm && this.baseForm.model) {
      this.appDataService.setAppData(APP_DATA_KEYS.previousModel, JSON.parse(JSON.stringify(this.baseForm.model)));
    }
  }

  exit() {
    this.navigateBackToHome();
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    this.navigateBackToHome();
  }

  buttonClick(event: any): void {
    this.logEvent('buttonClick', event);
  }

  actionButtonClick(event: any): void {
    this.logEvent('actionButtonClick', event);
    switch (event?.field?.field?.key) {
      case 'applications': {
        alert(event?.field?.type + 'button clicked on applications list');
        switch (event?.field?.type) {
          case 'download':
            //this.appDataService.generatePdf(API_ENDPOINTS.fee.invoice.replace('{feeId}', event.field.data.feeId));
            break;
          case 'payment':
            //this.router.navigate(['/' + RouteConstants.payment.paymentPrefix, event.field.data.feeId]);
            break;
        }
        break;
      }
    }
  }

  dialogSubmit(event: any): void {
    this.logEvent('dialogSubmit', event);
  }

  filter(event: any): void {
    this.logEvent('filter', event);
  }

  modelChange(event: any): void {
    this.logEvent('modelChange', event);
  }

  private navigateBackToHome(ignoreUnsavedChanges = false): void {
    this.navigate(['/', ROUTE_CONSTANTS.home], ignoreUnsavedChanges);
  }

  private saveData(request: SaveDataRequest) {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(API_ENDPOINTS.paymentRule.save, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            if (SERVER_ERROR_POP_UP_CODES.saveReferenceData.includes(data.message)) {
              this.activeDialog = data.message;
            }
            else {
              this.id = data.id;
              this.activeDialog = POP_UP_CODES.common.saveSuccessful;
            }
            this.dialogService.showDialog(this.activeDialog);
          }
        })
    );

  }

  private logEvent(handlerName: string, event?: any): void {
    console.log(`Event handler "${handlerName}" called: event = ${JSON.stringify(event)}`);
  }
}
